import React from 'react';

interface TaskFilterProps {
    fill?: string;
}

export const TaskFilter = ({ fill = '#818998' }: TaskFilterProps) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3296_6397)">
                <g clipPath="url(#clip1_3296_6397)">
                    <path
                        d="M16 1.33325V2.66659H0V1.33325H16ZM5.33333 14.6666H10.6667V13.3333H5.33333V14.6666ZM2.66667 8.66659H13.3333V7.33325H2.66667V8.66659Z"
                        fill={fill}
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_3296_6397">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
                <clipPath id="clip1_3296_6397">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
